import { ControlTable } from "../../../../src/components/strongMayor.js";
import * as React from 'react';
export default {
  ControlTable,
  React
};